var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupefina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002676",
    filter: "url(#filter0_d_864_898)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 150,
    cy: 144,
    r: 85,
    fill: "#F3F8FE",
    stroke: "white",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_864_898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M172.209 95.2046C174.216 95.8085 176.292 96.1318 178.273 96.8803C188.192 100.606 194.843 111.196 193.789 121.693C192.666 132.938 183.973 142.532 173.161 144.183C172.872 144.225 170.822 144.565 170.533 144.591C169.903 144.965 171.162 144.217 170.533 144.591C167.258 144.404 163.975 144.531 160.7 144.48C159.977 144.472 159.22 144.591 158.607 144.03C158.59 136.544 158.582 129.067 158.565 121.582C158.556 118.205 158.556 118.205 155.248 118.205C149.081 118.205 142.905 118.214 136.738 118.197C136.219 118.197 135.649 118.401 135.182 117.984C135.803 117.414 136.585 117.593 137.3 117.593C143.475 117.576 149.65 117.584 155.817 117.584C157.723 117.584 158.012 117.133 157.485 115.253C156.251 110.805 154.142 106.824 150.935 103.498C147.907 100.359 144.258 98.1392 140.056 96.8718C139.392 96.6761 138.703 96.5741 138.082 96.2508C137.657 95.9361 137.155 95.8766 136.645 95.8511C136.424 95.8255 136.211 95.749 136.032 95.6129C135.913 95.4853 135.913 95.3577 136.015 95.2131C148.077 95.2046 160.139 95.2046 172.209 95.2046Z",
    fill: "#218BEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M136.007 95.5025C136.211 95.5025 136.058 95.9788 136.262 95.9788C136.704 96.3446 137.64 95.4515 138.091 95.8002C139.988 96.5828 142.012 96.9656 143.866 97.9012C149.183 100.589 153.223 104.485 155.834 109.852C156.94 112.123 157.859 114.42 158.14 116.98C158.284 118.316 157.536 117.959 156.94 117.959C151.556 117.976 146.18 117.967 140.796 117.967C138.916 117.967 137.044 117.976 135.173 117.976C131.362 113.799 127.526 109.648 123.749 105.438C120.704 102.035 117.497 98.7774 114.648 95.1963C120.883 95.1963 127.109 95.1963 133.344 95.1963",
    fill: "#126FE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M136.006 95.5023C135.122 95.4002 134.178 95.7745 133.335 95.2046C134.229 95.2046 135.113 95.2046 136.006 95.2046C136.015 95.3067 136.015 95.4002 136.006 95.5023Z",
    fill: "#4788E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M158.607 144.03C162.75 144.14 166.246 143.545 170.38 144.072C171.145 144.021 172.115 144.336 172.54 144.277C182.79 145.297 191.823 153.914 193.508 164.274C195.66 177.51 187.247 189.682 174.088 192.361C173.025 192.574 171.936 192.778 170.864 192.778C158.471 192.804 146.078 192.787 133.676 192.778C134.356 191.63 135.479 192.336 136.389 192.123C136.925 192.14 137.461 192.2 137.971 191.979C142.318 190.907 146.188 188.933 149.548 185.956C151.675 184.068 153.435 181.907 154.805 179.432C156.055 177.178 156.948 174.779 157.688 172.321C157.867 171.819 157.961 171.326 157.595 170.858C156.923 170.399 156.166 170.535 155.443 170.535C149.438 170.526 143.432 170.535 137.427 170.518C136.661 170.518 135.836 170.671 135.181 170.05C135.658 169.659 136.228 169.854 136.746 169.854C143.458 169.837 150.169 169.803 156.872 169.88C158.207 169.897 158.539 169.489 158.539 168.23C158.505 160.702 158.539 153.174 158.556 145.646C158.565 145.11 158.59 144.574 158.607 144.03Z",
    fill: "#186AEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M106.626 172.049C108.796 169.25 110.709 166.758 112.632 164.274C116.953 158.703 121.299 153.157 125.595 147.56C126.233 146.726 126.888 146.403 127.934 146.411C135.496 146.454 143.05 146.437 150.611 146.437C151.037 146.437 151.462 146.437 152.245 146.437C151.403 147.517 150.765 148.351 150.11 149.176C144.385 156.397 138.643 163.619 132.944 170.858C132.272 171.708 131.583 172.074 130.461 172.066C123.103 172.015 115.736 172.04 108.379 172.04C107.945 172.049 107.511 172.049 106.626 172.049Z",
    fill: "#24DDA4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M152.16 141.716C143.645 141.716 135.445 141.716 127.237 141.725C126.692 141.725 126.327 141.563 125.986 141.121C119.615 132.904 113.236 124.695 106.848 116.479C107.179 116.019 107.613 116.223 107.962 116.223C115.575 116.206 123.188 116.215 130.792 116.206C131.49 116.206 132.068 116.24 132.587 116.904C138.873 124.883 145.202 132.836 151.513 140.798C151.7 141.01 151.845 141.257 152.16 141.716Z",
    fill: "#1B69EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M157.978 172.415C155.137 182.809 148.681 189.589 138.09 192.251C137.648 192.6 137.053 192.183 136.61 192.549C135.632 192.642 134.629 192.336 133.684 192.778C127.398 192.778 121.104 192.778 114.597 192.778C114.962 192.353 115.201 192.072 115.447 191.8C121.878 184.672 128.308 177.544 134.739 170.424C134.867 170.28 135.037 170.178 135.19 170.059C142.403 170.067 149.616 170.067 156.829 170.093C157.459 170.093 158.335 169.795 158.258 170.977C158.131 171.564 158.131 171.564 157.978 172.415Z",
    fill: "#1330CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M136.602 192.549C137.019 192.064 137.58 192.311 138.082 192.251C137.674 192.753 137.104 192.489 136.602 192.549Z",
    fill: "#426BDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M133.336 95.2046C133.336 95.2046 137.521 95.0345 142.412 97.2886L132.477 96.3444L133.336 95.2046Z",
    fill: "#126FE4"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_864_898",
    x: 0,
    y: 0,
    width: 300,
    height: 300,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.168627 0 0 0 0 0.352941 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_864_898"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_864_898",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_864_898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.2725,
    height: 97.5904,
    fill: "white",
    transform: "translate(106.626 95.2046)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupefina);
export default __webpack_public_path__ + "static/media/supefina.3703698d0150cae210bae9596d41193e.svg";
export { ForwardRef as ReactComponent };